import React, { useRef, useMemo, useState } from 'react';
import ReactQuill from 'react-quill';
import { AppColors } from '../Utils/helper/AppColors';
import 'react-quill/dist/quill.snow.css';
import ImageEditModal from './ImageEditModal'; // import your modal

const formats = [
	'header',
	'font',
	'size',
	'bold',
	'italic',
	'underline',
	'strike',
	'blockquote',
	'list',
	'bullet',
	'indent',
	'link',
	'image',
	'video',
	'color',
];
// const modules = {
// 	toolbar: [
// 		[{ size: [] }],
// 		['bold', 'italic', 'underline', 'strike', 'blockquote'],
// 		[{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
// 		['link'],
// 		['clean'],
// 		[{ color: Object.values(AppColors) }],
// 	],
// };

export default function QuillField(props) {
	const quillRef = useRef();
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);

	const imageHandler = () => {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();

		input.onchange = () => {
			const file = input.files[0];
			if (file) {
				const reader = new FileReader();
				reader.onload = () => {
					setSelectedImage(reader.result);
					setModalOpen(true);
				};
				reader.readAsDataURL(file);
			}
		};
	};

	// When done cropping/editing, insert into Quill
	const handleImageDone = (croppedBase64) => {
		setModalOpen(false);
		setSelectedImage(null);
		const editor = quillRef.current.getEditor();
		const range = editor.getSelection();
		editor.insertEmbed(range.index, 'image', croppedBase64);
		editor.setSelection(range.index + 1);
	};

	const modules = useMemo(
		() => ({
			toolbar: {
				container: [
					[{ size: [] }],
					['bold', 'italic', 'underline', 'strike'],
					[
						{ list: 'ordered' },
						{ list: 'bullet' },
						{ indent: '-1' },
						{ indent: '+1' },
					],
					['image', 'link'],
					['clean'],
					[{ color: Object.values(AppColors) }],
				],
				handlers: {
					image: imageHandler,
				},
			},
		}),
		[]
	);
	return (
		<>
			<ReactQuill
				ref={quillRef}
				modules={modules}
				formats={formats}
				style={{ borderRadius: 20 }}
				{...props}
			/>
			<ImageEditModal
				open={modalOpen}
				image={selectedImage}
				onClose={() => setModalOpen(false)}
				onDone={handleImageDone}
			/>
		</>
	);
}
